import { put, call, all, fork, select, takeLatest } from "redux-saga/effects";
import { visitsApiUpsellProvider } from "../../lib/api/providers";

import {
  VISIT_SET_FILTERS,
  VISIT_FILTERS_LOADING,
  VISIT_SET_VISITS,
  VISIT_VISITS_LOADING,
  VISIT_SET_PAGINATION,
  VISIT_SET_CURRENT_FILTERS,
  VISIT_GET_DYNAMIQUE_FILTER_VALUES, //TODO Remove once phototheque is updated
  VISIT_SET_SORT,
  VISIT_SET_KEY_FILTER_SELECTED
} from "../types";
import { selectUserInfos } from "../selectors/user";
import hacks from "../../configs/hacks";
import { roles } from "../../configs/constants";

const getVisitState = state => state.visit;
const getState = state => state;

const getFiltersValuesApi = (state, clientId, globalState) => {
  const currentFiltersToSend = { ...state.currentFilters };
  delete currentFiltersToSend[state.keyFilterSelected];
  //hack
  //TODO refactor (match, currentFiltersToSend, ...)
  const userInfos = selectUserInfos(globalState);
  const match = {};
  const hacksInstance = hacks(userInfos, globalState.currentClient.id);
  if (!hacksInstance.visits.removeSectorLimitationToTerrain && userInfos.role_id === roles.TERRAIN) {
    match["sector_id"] = userInfos.sectors.map(sector => sector.sector_id);
  }

  if (hacksInstance.visits.selfContentOnlyToTerrain && userInfos.role_id === roles.TERRAIN) {
    match["user_email"] = [userInfos.email];
  }

  if (state.keyFilterSelected === "period") {
    return visitsApiUpsellProvider
      .post(`/range/startDate/endDate`, {
        match: { ...currentFiltersToSend, ...match }
      })
      .then((response = {}) => {
        return response.data;
      });
  } else {
    return visitsApiUpsellProvider
      .post(`/distincts/${state.keyFilterSelected}`, {
        match: { ...currentFiltersToSend, client_id: clientId, ...match }
      })
      .then((response = {}) => {
        return response.data;
      });
  }
};

const getVisitsApi = state => {
  const { currentFilters, sort, page, pageSize } = state.visit;
  const userInfos = selectUserInfos(state);
  let match = { ...currentFilters, client_id: state.currentClient.id };

  if (userInfos.email === "screlec@upsell.fr") {
    match["salepoint.eo_piles"] = ["SCRELEC", "SCRELEC; COREPILE"];
  }
  if (userInfos.email === "corepile@upsell.fr") {
    match["salepoint.eo_piles"] = ["COREPILE", "SCRELEC; COREPILE"];
  }

  //hack
  const hacksInstance = hacks(userInfos, state.currentClient.id);
  if (!hacksInstance.visits.removeSectorLimitationToTerrain && userInfos.role_id === roles.TERRAIN) {
    match["sector_id"] = userInfos.sectors.map(sector => sector.sector_id);
  }

  if (hacksInstance.visits.selfContentOnlyToTerrain && userInfos.role_id === roles.TERRAIN) {
    match["user_email"] = [userInfos.email];
  }

  return visitsApiUpsellProvider
    .post(`/`, {
      match,
      sort: sort,
      page: page > 0 ? page : 1,
      pageSize: pageSize,
      project: {
        _id: 1,
        user_fullName: 1,
        sector_label: 1,
        retailer_label: 1,
        pdc_label: 1,
        pdc_id: 1,
        title: 1,
        startDate: 1,
        endDate: 1,
        "salepoint.city": 1,
        version: 1
      }
    })
    .then((response = {}) => {
      return response.data;
    });
};

function* getVisits() {
  try {
    yield put({ type: VISIT_VISITS_LOADING, loading: true });
    const state = yield select(getState);
    const data = yield call(getVisitsApi, state);
    if (!Array.isArray(data.docs)) {
      throw new Error("No visits");
    }
    yield put({ type: VISIT_SET_VISITS, payload: data });
    yield put({ type: VISIT_VISITS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: VISIT_VISITS_LOADING, loading: false });
  }
}

function* getFiltersValues() {
  try {
    yield put({ type: VISIT_FILTERS_LOADING, loading: true });
    const state = yield select(getVisitState); //TODO refactor to visitState
    const globalState = yield select(getState);
    const currentClientId = globalState.currentClient ? globalState.currentClient.id : null;

    const values = yield call(getFiltersValuesApi, state, currentClientId, globalState);

    if (values.length <= 0) {
      throw new Error("No filters");
    }
    yield put({
      type: VISIT_SET_FILTERS,
      values: values,
      key: state.keyFilterSelected
    });
    yield put({ type: VISIT_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: VISIT_FILTERS_LOADING, loading: false });
  }
}

function* watchFecthVisits() {
  yield takeLatest(VISIT_SET_CURRENT_FILTERS, getVisits);
}

function* watchFetchVisitsPagination() {
  yield takeLatest(VISIT_SET_PAGINATION, getVisits);
}

function* wathFetchDynFilterValues() {
  console.log("dyn");
  //TODO Remove once phototheque is updated
  yield takeLatest(VISIT_GET_DYNAMIQUE_FILTER_VALUES, getFiltersValues);
}

function* watchSetKeyFilterSelected() {
  console.log("select");
  yield takeLatest(VISIT_SET_KEY_FILTER_SELECTED, getFiltersValues);
}

function* watchSortVisits() {
  yield takeLatest(VISIT_SET_SORT, getVisits);
}

export default function* root() {
  yield all([
    fork(wathFetchDynFilterValues), //TODO Remove once phototheque is updated
    fork(watchFetchVisitsPagination),
    fork(watchFecthVisits),
    fork(watchSortVisits),
    fork(watchSetKeyFilterSelected)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/visitSagas.js